var pix = document.getElementsByClassName("transcend-box");

for (var i = 0; i < pix.length; i++) {
    pix[i].style.animationDelay = Math.ceil(Math.random()*12000)+"ms";
}